import { WebApiService } from '../../plugins/webApiService'
import { Events } from '../../plugins/events'
import { SendRequestModel } from '../../plugins/models/SendRequestModel'
import AllowNotificationRequest from '../../notifications/i-service/models/AllowNotificationRequest';
import AllowProviderRequest from '../../notifications/i-service/models/AllowProviderRequest';
import CheckNotificationRequest from '../../notifications/i-service/models/CheckNotificationRequest';
import GetUnReadNotificationRequest from '../../notifications/i-service/models/GetUnReadNotificationRequest';
import GetNotificationByUserIdRequest from '../../notifications/i-service/models/GetNotificationByUserIdRequest';
import UpdateReadNotificationRequest from '../../notifications/i-service/models/UpdateReadNotificationRequest';
import GetNotificationByIdRequest from '../../notifications/i-service/models/GetNotificationByIdRequest';
import SendStatusNotificationsRequest from '../../notifications/i-service/models/SendStatusNotificationsRequest';
import SendPriorityNotificationRequest from '../../notifications/i-service/models/SendPriorityNotificationRequest';
import SendAddCommentNotificationRequest from '../../notifications/i-service/models/SendAddCommentNotificationRequest';
import WsResponseModelT from '../../schema-builder-server/models/WsResponseModelT';
import AlertPermissions from '../../notifications/i-service/models/AlertPermissions';
import NotificationProviderResponse from '../../notifications/i-service/models/NotificationProviderResponse';
import UnReadNotificationResponse from '../../notifications/i-service/models/UnReadNotificationResponse';
import NotificationHistoryList from '../../notifications/i-service/models/NotificationHistoryList';
import NotificationHistoryResponse from '../../notifications/i-service/models/NotificationHistoryResponse';
import PushNotificationResponse from '../../notifications/i-service/models/PushNotificationResponse';

export default class NotificationsService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	AllowNotificationsAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	AllowProviderAsyncEvent = new Events<WsResponseModelT<Boolean>>();
	GetNotificationPermissionsAsyncEvent = new Events<WsResponseModelT<AlertPermissions>>();
	GetNotificationProviderAsyncEvent = new Events<WsResponseModelT<NotificationProviderResponse>>();
	GetUnReadNotificationEvent = new Events<WsResponseModelT<UnReadNotificationResponse>>();
	GetHistoryNotificationAsyncEvent = new Events<WsResponseModelT<NotificationHistoryList>>();
	UpdateReadNotificationEvent = new Events<WsResponseModelT<Boolean>>();
	GetNotificationAsyncEvent = new Events<WsResponseModelT<NotificationHistoryResponse>>();
	SendStatusNotificationEvent = new Events<WsResponseModelT<Boolean>>();
	SendPriorityNotificationEvent = new Events<WsResponseModelT<Boolean>>();
	SendAddCommentNotificationEvent = new Events<WsResponseModelT<Boolean>>();
	PushNotificationEvent = new Events<WsResponseModelT<PushNotificationResponse>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('NotificationsService', 'AllowNotificationsAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.AllowNotificationsAsyncEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'AllowProviderAsync', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.AllowProviderAsyncEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'GetNotificationPermissionsAsync', 'Main', (res: WsResponseModelT<AlertPermissions>) => {
			self.GetNotificationPermissionsAsyncEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'GetNotificationProviderAsync', 'Main', (res: WsResponseModelT<NotificationProviderResponse>) => {
			self.GetNotificationProviderAsyncEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'GetUnReadNotification', 'Main', (res: WsResponseModelT<UnReadNotificationResponse>) => {
			self.GetUnReadNotificationEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'GetHistoryNotificationAsync', 'Main', (res: WsResponseModelT<NotificationHistoryList>) => {
			self.GetHistoryNotificationAsyncEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'UpdateReadNotification', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateReadNotificationEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'GetNotificationAsync', 'Main', (res: WsResponseModelT<NotificationHistoryResponse>) => {
			self.GetNotificationAsyncEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'SendStatusNotification', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.SendStatusNotificationEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'SendPriorityNotification', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.SendPriorityNotificationEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'SendAddCommentNotification', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.SendAddCommentNotificationEvent.trigger(res);
		});
		webApiService.on('NotificationsService', 'PushNotification', 'Main', (res: WsResponseModelT<PushNotificationResponse>) => {
			self.PushNotificationEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * Изменение разрешения на получение оповещений определенного типа
	 */
	async AllowNotificationsAsync(request: AllowNotificationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'AllowNotificationsAsync',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Изменение разрешения на получение оповещений определенного провайдера
	 */
	async AllowProviderAsync(request: AllowProviderRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'AllowProviderAsync',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение разрешений на отправку типа оповещения
	 */
	async GetNotificationPermissionsAsync(request: CheckNotificationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'GetNotificationPermissionsAsync',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение разрешений на отправку в контакт оповещения
	 */
	async GetNotificationProviderAsync(request: CheckNotificationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'GetNotificationProviderAsync',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение не прочитанных оповещений пользователя
	 */
	async GetUnReadNotification(request: GetUnReadNotificationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'GetUnReadNotification',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение истории опопвещений определенного пользователя
	 */
	async GetHistoryNotificationAsync(request: GetNotificationByUserIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'GetHistoryNotificationAsync',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Меняет указанным сообщениям дату чтения в случае если они отсутствует
	 */
	async UpdateReadNotification(request: UpdateReadNotificationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'UpdateReadNotification',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение оповещения по номеру оповещения
	 */
	async GetNotificationAsync(request: GetNotificationByIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'GetNotificationAsync',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Рассылка оповещений о изменении статуса
	 */
	async SendStatusNotification(request: SendStatusNotificationsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'SendStatusNotification',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Рассылка опопвщений о изменни приоритета
	 */
	async SendPriorityNotification(request: SendPriorityNotificationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'SendPriorityNotification',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Рассылка оповещений о изменении комментария
	 */
	async SendAddCommentNotification(request: SendAddCommentNotificationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'NotificationsService',
			Method: 'SendAddCommentNotification',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Изменение разрешения на получение оповещений определенного типа
	 */
	async allowNotificationsAsyncAsync(request: AllowNotificationRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'AllowNotificationsAsync',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Изменение разрешения на получение оповещений определенного провайдера
	 */
	async allowProviderAsyncAsync(request: AllowProviderRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'AllowProviderAsync',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение разрешений на отправку типа оповещения
	 */
	async getNotificationPermissionsAsyncAsync(request: CheckNotificationRequest): Promise<AlertPermissions> {
		return new Promise<AlertPermissions>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'GetNotificationPermissionsAsync',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<AlertPermissions>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as AlertPermissions)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение разрешений на отправку в контакт оповещения
	 */
	async getNotificationProviderAsyncAsync(request: CheckNotificationRequest): Promise<NotificationProviderResponse> {
		return new Promise<NotificationProviderResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'GetNotificationProviderAsync',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<NotificationProviderResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as NotificationProviderResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение не прочитанных оповещений пользователя
	 */
	async getUnReadNotificationAsync(request: GetUnReadNotificationRequest): Promise<UnReadNotificationResponse> {
		return new Promise<UnReadNotificationResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'GetUnReadNotification',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<UnReadNotificationResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as UnReadNotificationResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение истории опопвещений определенного пользователя
	 */
	async getHistoryNotificationAsyncAsync(request: GetNotificationByUserIdRequest): Promise<NotificationHistoryList> {
		return new Promise<NotificationHistoryList>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'GetHistoryNotificationAsync',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<NotificationHistoryList>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as NotificationHistoryList)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Меняет указанным сообщениям дату чтения в случае если они отсутствует
	 */
	async updateReadNotificationAsync(request: UpdateReadNotificationRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'UpdateReadNotification',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение оповещения по номеру оповещения
	 */
	async getNotificationAsyncAsync(request: GetNotificationByIdRequest): Promise<NotificationHistoryResponse> {
		return new Promise<NotificationHistoryResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'GetNotificationAsync',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<NotificationHistoryResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as NotificationHistoryResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Рассылка оповещений о изменении статуса
	 */
	async sendStatusNotificationAsync(request: SendStatusNotificationsRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'SendStatusNotification',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Рассылка опопвщений о изменни приоритета
	 */
	async sendPriorityNotificationAsync(request: SendPriorityNotificationRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'SendPriorityNotification',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Рассылка оповещений о изменении комментария
	 */
	async sendAddCommentNotificationAsync(request: SendAddCommentNotificationRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'NotificationsService',
				Method: 'SendAddCommentNotification',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}